import { getCDNUrl } from './CDNUrl';

const salesCDN = (fileName) => getCDNUrl('order', fileName);

export const FINAL_EXAMPLE_PICTURE = salesCDN('FinalExamplePicture.jpg');
export const ULTRASOUNDIMAGE_EXAMPLE_PICTURE = salesCDN(
  'UltraSoundImageExamplePicture.jpg',
);
